import { useContext } from 'react';
import { HealthStatusContext, HealthStatusContextValue } from './healthStatusContextDef';

export const useHealthStatus = (): HealthStatusContextValue => {
  const context = useContext(HealthStatusContext);
  if (context === undefined) {
    throw new Error('useHealthStatus must be used within a HealthStatusProvider');
  }
  return context;
};
